import React from "react";
import styled from "styled-components";

// components
import { StyledText, CurveHolder } from "../common/basic";
import { Box } from "../common";

// svg
import { CardCurve } from "../svgs";

// hooks
import { useTheme } from "../../hooks/";

// theme
import theme from "../../theme";

const PrizeCard = ({
  prizeRange,
  img,
  prize,
  textPrize,
  description,
  onPress,
}) => {
  const { themeContext } = useTheme();
  const { activeTheme } = themeContext;

  const bgColor =
    activeTheme === "midnight"
      ? theme.colors[themeContext.activeTheme].mashupBackground
      : "#F2F2F2";

  const activeColor = theme.colors[themeContext.activeTheme].background;

  return (
    <TouchableHighlight
      onClick={() => {
        onPress();
      }}
    >
      <Box
        themeAware={false}
        style={{
          borderRadius: 20,
          height: 190,
          width: 161,
          margin: 10,
          backgroundColor: bgColor,
          shadowColor: activeTheme === "midnight" ? "black" : "#242424",
          shadowOffset: {
            width: 0,
            height: 0,
          },
          shadowOpacity: activeTheme === "midnight" ? 1 : 0.23,
          shadowRadius: 1.62,
          elevation: 4,
          justifyContent: "space-between",
        }}
      >
        {img ? (
          <>
            <FastImage
              style={{
                height: "60%",
                width: "100%",
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
                objectFit: "cover"
              }}
              src={img}
            />
            <CurveHolder top={-30}>
              <CardCurve width={"100%"} fill={bgColor} />
            </CurveHolder>
          </>
        ) : (
          <StyledText
            size={34}
            style={{
              textAlign: "center",
              color: activeTheme === "midnight" ? "white" : "black",
            }}
          >
            {textPrize}
          </StyledText>
        )}
        <Box themeAware={false} backgroundColor={"transparent"}>
          <Box
            themeAware={false}
            style={{ alignSelf: "center", backgroundColor: "transparent" }}
          >
            <StyledText
              align={"center"}
              margin={0}
              fontFamily={"medium"}
              size={12}
            >
              {description}
            </StyledText>
          </Box>
          <Box
            themeAware={false}
            backgroundColor={"transparent"}
            style={{
              display: "grid",
              borderRadius: 20,
              padding: 5,
              gridAutoFlow: "column",
              justifyContent: "center",
            }}
          >
            <StyledText
              fontFamily={"medium"}
              size={11}
              align={"center"}
              style={{ textAlign: "center", paddingLeft: 5, paddingRight: 5 }}
            >
              {prize}
            </StyledText>
            <StyledText
              size={16}
              style={{ textAlign: "center", paddingLeft: 5, paddingRight: 5 }}
            >
              {prizeRange && (
                <StyledText style={{ margin: 0, padding: 0 }}>|</StyledText>
              )}
            </StyledText>
            {prizeRange && (
              <StyledText
                fontFamily={"medium"}
                size={11}
                style={{ textAlign: "center", color: activeColor }}
              >
                {prizeRange}
              </StyledText>
            )}
          </Box>
        </Box>
      </Box>
    </TouchableHighlight>
  );
};

const TouchableHighlight = styled.div``;

const FastImage = styled.img``;

export default PrizeCard;
